export class SubAPI {
    constructor(parent) { this.fetcher = void 0; this.fetcher = parent.fetcher; }
}
